export default __webpack_public_path__ + "fd410a339be93f62555b4efc484dafab.jpg";